import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import BannerImage from "./banner-image";
import { Carousel } from "react-bootstrap";

const ConferenceCarousel = () => {
  const [documentLength, setDocumentLength] = useState(0);
  const { conferenceDocuments } = useSelector(
    (state) => state.conferenceDetails
  );

  useEffect(() => {
    setDocumentLength(conferenceDocuments?.items?.length);
  }, [conferenceDocuments]);

  return (
    <>
      {documentLength === 1 && (
        <div className="ku-conference-image">
          <BannerImage
            conferenceDocuments={
              conferenceDocuments.items[0].documentPreviewURL
            }
            alt={`conference`}
          />
        </div>
      )}
      {documentLength > 1 && (
        <Carousel>
          {conferenceDocuments?.items?.map((item, index) => (
            <Carousel.Item key={index}>
                <BannerImage
                  conferenceDocuments={item?.documentPreviewURL}
                  alt={`conference ${index}`}
                />
            </Carousel.Item>
          ))}
        </Carousel>
      )}
    </>
  );
};

export default ConferenceCarousel;
